import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HubspotService {

  private API_PATH = 'crm/v3/objects/';
  private PROXY_URL = environment.endPointHubspot;

  deals: any[];

  pipeline: string;
  stages: any;

  constructor(private http: HttpClient) {
    if (environment.env === 'prod') {
      this.stages = {
        ['cart_abandoned']: '114894392',
        ['view']: '114894393',
        ['info']: '131699065',
        ['calculator']: '114894394',
        ['download']: '114894395',
        ['add_to_cart']: '114894396',
        ['reservation']: '114942039',
        ['test']: '114942040',
        ['checkout']: '114942041',
        ['sign']: '114942042',
        ['payment']: '114942043',
        ['ok']: '114894397',
        ['cancel']: '114894398',
        ['validation']: '138421581',
        ['preinvestment']: '1311814033',
        ['investmentIntention']: '1311814032',
        ['cancel_pre_investment']: '1324322943',
      };
      this.pipeline = '57904999';
    } else {
      this.stages = {
        ['cart_abandoned']: '114948656',
        ['view']: '77900719',
        ['info']: '131381275',
        ['calculator']: '114894371',
        ['download']: '105683575',
        ['add_to_cart']: '114948657',
        ['reservation']: '105683576',
        ['test']: '105683577',
        ['checkout']: '105683578',
        ['sign']: '105683579',
        ['payment']: '105683580',
        ['ok']: '98891150',
        ['cancel']: '105683581',
        ['validation']: '138478212',
        ['preinvestment']: '1311814184',
        ['investmentIntention']: '1307724697',
        ['cancel_pre_investment']: '1323406728',
      };
      this.pipeline = '34570783';
    }
  }

  getStage(key: string) {
    return this.stages[key];
  }

  searchContact(email: string): Observable<any> {
    const path = `${this.API_PATH}contacts/search`;
    const params = {
      "filterGroups": [
        {
          "filters": [
            {
              "value": email,
              "propertyName": "email",
              "operator": "EQ"
            }
          ]
        },
        {
          "filters": [
            {
              "value": email,
              "propertyName": "hs_additional_emails",
              "operator": "CONTAINS_TOKEN"
            }
          ]
        },
      ]
    };
    const options = {
      path: path,
      params: params
    };
    return this.http.post(`${this.PROXY_URL}`, options);
  }

  updateContact(id: string, props: any): Observable<any> {
    const path = `${this.API_PATH}contacts/${id}`;
    const params = {
      "properties": props
    };
    const options = {
      path: path,
      params: params
    };
    return this.http.patch(`${this.PROXY_URL}`, options);
  }

  getDeals(email: string, project: string): Observable<any> {
    console.log('[HubSpot] getDeals → buscando deals. Email (referencias):', email, '| Proyecto:', project);
    const path = `${this.API_PATH}deals/search`;
    const params = {
      "filterGroups": [
        {
          "filters": [
            {
              "value": email,
              "propertyName": "referencias",
              "operator": "EQ"
            },
            {
              "value": project,
              "propertyName": "project",
              "operator": "EQ"
            },
            // {
            //   "value": `${this.stages['ok']}`, // Etapa Final inversión realizada
            //   "propertyName": "dealstage",
            //   "operator": "NEQ"
            // }
          ]
        }
      ],
      "properties": ["referencias", "project", "dealstage", "dealname"]
    };
    const obs = this.http.post(`${this.PROXY_URL}`, { path: path, params: params });
    obs.subscribe((res: any) => {
      const deals = res?.data?.results || [];
      console.log('[HubSpot] getDeals → resultado:', deals.length, 'deal(s) encontrados');
      deals.forEach((d: any, i: number) => {
        console.log(`[HubSpot] getDeals → deal[${i}]:`, {
          id: d.id,
          referencias: d.properties?.referencias,
          dealstage: d.properties?.dealstage,
          project: d.properties?.project,
        });
      });
    });
    return obs;
  }

  createDeal(id: string, props: any): Observable<any> {
    console.log('[HubSpot] createDeal → contactoId:', id, '| props:', props);
    const path = `${this.API_PATH}deals`;
    props.dealstage = `${this.stages['view']}`;
    props.pipeline = `${this.pipeline}`;
    const params = {
      "properties": props,
      "associations": [
        {
          "to": {
            "id": id // Id del contacto
          },
          "types": [
            {
              "associationCategory": "HUBSPOT_DEFINED",
              "associationTypeId": 3
            }
          ]
        }
      ]
    };
    const options = {
      path: path,
      params: params
    };
    const obs = this.http.post(`${this.PROXY_URL}`, options);
    obs.subscribe((res: any) => {
      console.log('[HubSpot] createDeal → deal creado:', { id: res?.data?.id, referencias: res?.data?.properties?.referencias });
    });
    return obs;
  }

  updateDeal(id: string, stage: string, props: any): Observable<any> {
    console.log('[HubSpot] updateDeal → dealId:', id, '| stage:', stage, '| props:', props);
    const path = `${this.API_PATH}deals/${id}`;
    const newStage = this.stages[stage];
    props.dealstage = `${newStage}`;
    const params = {
      "properties": props
    };
    const options = {
      path: path,
      params: params
    };
    const obs = this.http.patch(`${this.PROXY_URL}`, options);
    obs.subscribe((res: any) => {
      console.log('[HubSpot] updateDeal → respuesta:', { id: res?.data?.id, dealstage: res?.data?.properties?.dealstage, referencias: res?.data?.properties?.referencias });
    });
    return obs;
  }

  searchProduct(sku: number): Observable<any> {
    const path = `${this.API_PATH}products/search`;
    const params = {
      "filterGroups": [
        {
          "filters": [
            {
              "value": sku,
              "propertyName": "hs_sku",
              "operator": "EQ"
            }
          ]
        }
      ]
    };
    const options = {
      path: path,
      params: params
    };
    return this.http.post(`${this.PROXY_URL}`, options);
  }

  createOrder(product: number, price: number): Observable<any> {
    const path = `${this.API_PATH}line_items`;
    const params = {
      "properties": {
        "quantity": 1,
        "price": price,
        "hs_product_id": product
      }
    };
    const options = {
      path: path,
      params: params
    };
    return this.http.post(`${this.PROXY_URL}`, options);
  }

  associateDealOrder(deal: number, order: number): Observable<any> {
    const path = `${this.API_PATH}deals/${deal}/associations/line_items/${order}/19`;
    const options = {
      path: path,
      params: {}
    };
    return this.http.put(`${this.PROXY_URL}`, options);
  }

  canTransitionStage(currentStageId: string, targetStageKey: string): boolean {
    if (currentStageId === this.stages['investmentIntention']) {
      return ['preinvestment', 'sign', 'ok', 'cancel', 'cancel_pre_investment'].includes(targetStageKey);
    }
    if (currentStageId === this.stages['preinvestment']) {
      return ['sign', 'ok', 'cancel', 'cancel_pre_investment'].includes(targetStageKey);
    }
    return true;
  }

  resetTracking() {
    const hsCookies = ['hubspotutk', '__hstc', '__hssc', '__hssrc'];
    const before: Record<string, string> = {};
    hsCookies.forEach(name => {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      before[name] = match ? match[1] : '(no encontrada)';
    });
    console.log('[HubSpot] resetTracking → cookies ANTES:', before);

    hsCookies.forEach(name => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
    });

    const after: Record<string, string> = {};
    hsCookies.forEach(name => {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      after[name] = match ? match[1] : '(borrada)';
    });
    console.log('[HubSpot] resetTracking → cookies DESPUÉS:', after);

    const hsq: any[] = (window as any)._hsq = (window as any)._hsq || [];
    hsq.push(['revokeCookieConsent']);
    console.log('[HubSpot] resetTracking → revokeCookieConsent enviado a _hsq');
  }

  identifyContact(email: string) {
    const hsCookies = ['hubspotutk', '__hstc', '__hssc', '__hssrc'];
    const cookies: Record<string, string> = {};
    hsCookies.forEach(name => {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      cookies[name] = match ? match[1] : '(no encontrada)';
    });
    console.log(`[HubSpot] identifyContact → email: ${email} | cookies actuales:`, cookies);

    const hsq: any[] = (window as any)._hsq = (window as any)._hsq || [];
    hsq.push(['identify', { email }]);
    hsq.push(['trackPageView']);
    console.log('[HubSpot] identifyContact → identify + trackPageView enviados a _hsq');
  }

  createTask(subject: string, body: string): Observable<any> {
    const path = `${this.API_PATH}tasks`;
    const params = {
      "properties": {
        "hs_timestamp": new Date().toISOString(),
        "hs_task_body": body,
        "hubspot_owner_id": "82243645", // ID del propietario de la tarea - Sarah
        "hs_task_subject": subject,
        "hs_task_status": "WAITING",
        "hs_task_priority": "HIGH",
        "hs_task_type": "CALL"
      }
    };
    const options = {
      path: path,
      params: params
    };
    return this.http.post(`${this.PROXY_URL}`, options);
  }

}